/**
 * @generated SignedSource<<854a0fb33c75d20994851e58ba70b7d8>>
 * @relayHash 4b5573095a61305807083f613fadee86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc2e255ff9a71c630ed851a906097f48c12e8ec0bfa8ea8eb9d98357830b5be5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery$variables = {
  amountOfColumns?: number | null | undefined;
  cloudId: string;
  issueKey?: string | null | undefined;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData">;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery = {
  response: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery$data;
  variables: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "amountOfColumns"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "issueKey",
                "variableName": "issueKey"
              }
            ],
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasDefaultFieldSets"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "fieldSetSelectedState": "SELECTED"
                        }
                      },
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                      }
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "type"
                              },
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isSortable"
                              },
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "width"
                                  }
                                ]
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isPlaceHolderField"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldType",
                                "kind": "LinkedField",
                                "name": "fieldType",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalCount"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ],
                "type": "JiraFieldSetView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fc2e255ff9a71c630ed851a906097f48c12e8ec0bfa8ea8eb9d98357830b5be5",
    "metadata": {},
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_FieldSetViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "435565a157cb15d754010df2fa9a87cb";

export default node;
